import { loadCSS } from '../utils';
let view = null;

export default {
	namespace: 'template-film-series-engage',
	beforeEnter: async ({ current, next, trigger }) => {
		await loadCSS(WPURLS.themeUrl + '/dist/css/_film-series-engage.css');

		const { default: FilmSeriesEngage } = await import(/* webpackChunkName: "film-series-engage" */ '../film-series/FilmSeriesEngage');
		view = new FilmSeriesEngage(next.container);
		view.init();
	},
	afterEnter: () => {
		// document.body.classList.add('body--black');
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
